import PropTypes from 'prop-types';
import React, { useState } from 'react';

import Dropdown from 'components/Dropdown';
import { mediumUp } from 'constants/mediaQueries';
import ProductModel from 'models/Product';
import VariantModel from 'models/Variant';
import Theme from 'styles/theme';
import I18n from 'utils/I18n';
import { StoreLocationUtils } from 'utils/StoreLocation';

import DropdownContent from './DropdownContent';
import StoreInventoryModal from './StoreInventoryModal';

const PdpStoreInventory = ({
  isModalOpen,
  closeModal,
  openModal,
  dropdownToggled,
  callToReserveClicked,
  storeSelected,
  storeSaved,
  searchCompleted,
  product,
  variant,
  preferredStoreHandle,
  setPreferredStore,
  storeLocationContentByVariant,
  defaultSortedList,
}) => {
  const [isAccordionOpen, setIsAccordionOpen] = useState(true);
  const [shopSortOrder, setShopSortOrder] = useState([]);

  const preferredStore = storeLocationContentByVariant[preferredStoreHandle];

  const sortShops = origin => {
    const updatedShopOrder = StoreLocationUtils.sortLocationsByDistanceFromOrigin(
      storeLocationContentByVariant,
      origin
    );
    setShopSortOrder(updatedShopOrder);
  };

  return (
    <div className="PdpStoreInventory">
      <Dropdown
        className="PdpStoreInventory__dropdown"
        content={
          <DropdownContent
            openModal={openModal}
            variant={variant}
            preferredStore={preferredStore}
            callToReserveClicked={callToReserveClicked}
          />
        }
        dropdownHeader={I18n.localize('pdp.storeInventory.findInStore')}
        isOpen={isAccordionOpen}
        onClick={() => {
          setIsAccordionOpen(!isAccordionOpen);
          dropdownToggled();
        }}
        key={I18n.localize('pdp.storeInventory.findInStore')}
      />
      <StoreInventoryModal
        isOpen={isModalOpen}
        closeModal={() => closeModal(false)}
        product={product}
        variant={variant}
        sortShops={sortShops}
        setPreferredStore={setPreferredStore}
        preferredStore={preferredStore}
        sortedStores={shopSortOrder}
        defaultSortedList={defaultSortedList}
        storeList={storeLocationContentByVariant}
        storeSelected={storeSelected}
        storeSaved={storeSaved}
        searchCompleted={searchCompleted}
      />

      <style jsx global>{`
        .PdpStoreInventory__dropdown {
          margin-top: ${Theme.get('spacing') * 2}px;
          border-top: 1px solid ${Theme.get('colors-black-20')};
        }

        .PdpStoreInventory__dropdown:last-child {
          border-bottom: none;
        }

        @media ${mediumUp} {
          .PdpStoreInventory__dropdown:last-child {
            border-bottom: 1px solid ${Theme.get('colors-black-20')};
          }
        }
      `}</style>
    </div>
  );
};

PdpStoreInventory.propTypes = {
  product: PropTypes.instanceOf(ProductModel),
  variant: PropTypes.instanceOf(VariantModel),
  openModal: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
  setPreferredStore: PropTypes.func.isRequired,
  preferredStoreHandle: PropTypes.string,
  isModalOpen: PropTypes.bool,
  dropdownToggled: PropTypes.func.isRequired,
  callToReserveClicked: PropTypes.func.isRequired,
  storeSelected: PropTypes.func.isRequired,
  storeSaved: PropTypes.func.isRequired,
  searchCompleted: PropTypes.func.isRequired,
  storeLocationContentByVariant: PropTypes.object.isRequired,
  defaultSortedList: PropTypes.arrayOf(
    PropTypes.shape({
      handle: PropTypes.string.isRequired,
    })
  ),
};

PdpStoreInventory.defaultProps = {
  isModalOpen: false,
  preferredStore: null,
};

export default PdpStoreInventory;
